<template>
    <div class="flex flex-col gap-4 p-6 rounded-xl">
        <div class="flex items-center justify-between">
            <h3 class="text-lg font-semibold text-gray-500">Linked Wallets</h3>
        </div>

        <div v-show="ui.wallet" class="flex flex-col gap-4">
            <div class="flex items-center gap-8 justify-start flex-wrap mt-12">
                <button
                    class="wall_btn_ cursor-pointer w-16 h-16 bg-gray-700 p-2 flex items-center justify-center border border-gray-500 rounded-md relative"
                    @click="connectMetamask">
                    <img class="w-12 h-12 object-contain" src="@/assets/images/MetaMask_Fox.png" alt="MetaMask" />
                    <span v-if="isMetamaskConnected"
                        class="absolute top-0 right-0 bg-green-500 rounded-full w-5 h-5 flex items-center justify-center text-white text-sm">
                        ✓
                    </span>
                </button>
                <button
                    class="wall_btn_c cursor-pointer w-16 h-16 bg-gray-700 p-2 flex items-center justify-center border border-gray-500 rounded-md">
                    <img class="w-12 h-12 object-contain" src="@/assets/images/coinbase.png" alt="Coinbase" />
                </button>
                <button
                    class="wall_btn_c cursor-pointer w-16 h-16 bg-gray-700 p-2 flex items-center justify-center border border-gray-500 rounded-md">
                    <img class="w-12 h-12 object-contain" src="@/assets/images/binance.png" alt="Binance" />
                </button>
                <button
                    class="wall_btn_c cursor-pointer w-16 h-16 bg-gray-700 p-2 flex items-center justify-center border border-gray-500 rounded-md">
                    <img class="w-12 h-12 object-contain" src="@/assets/images/rabby.png" alt="Rabby" />
                </button>
            </div>


            <div v-if="isMetamaskConnected" class="connect_info_container">
                 <hr class="w-1/2 border border-gray-500 mt-6 mb-6" />
                <div class="flex items-center gap-4">
                    <img class="w-8 h-8 object-contain" src="@/assets/images/MetaMask_Fox.png" alt="MetaMask" />
                    <div>
                        <p>Wallet Address</p>
                        <address>{{ publicAddress }}</address>
                    </div>
                </div>
                <div class="flex items-center gap-4 mt-4">
                    <button class="text-red text-lg font-semibold w-1/2 hover:text-gray-300 border border-gray-500 px-4 py-4 cursor-pointer rounded-lg bg-transparent"
                        @click="disconnectWallet">
                        Disconnect
                    </button>
                </div>
            </div>

            <hr class="w-1/2 border border-gray-500 mt-6 mb-6" />

            <div>
                <button
                    class="text-white text-lg font-semibold w-1/2 hover:text-gray-300 border border-gray-500 px-4 py-4 cursor-pointer rounded-lg bg-transparent">
                    Add a Wallet +
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import Web3 from 'web3';

export default {
    name: 'Wallet',
    data() {
        return {
            ui: {
                wallet: true, // Set to true to always show wallet options
            },
            publicAddress: '',
            isMetamaskConnected: false,
            isRequestingAccounts: false,
        };
    },
    mounted() {
        // Check if MetaMask is already connected on page load
        this.checkMetamaskConnection();
    },
    methods: {
        async connectMetamask() {
            if (this.isRequestingAccounts) return;
            this.isRequestingAccounts = true;

            document.getElementById('loading-bg-transparent-title').innerText =
                'Connecting to MetaMask';
            document.getElementById('loading-bg-transparent').style.display = 'flex';

            try {
                const web3 = new Web3(Web3.givenProvider);
                if (!web3.givenProvider) {
                    this.$vs.notify({
                        title: 'Wallet Connection',
                        text: 'Please install MetaMask to continue.',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'warning',
                    });
                    this.isRequestingAccounts = false;
                    return;
                }

                const accounts = await this.withTimeout(
                    window.ethereum.request({ method: 'eth_requestAccounts' }),
                    15000
                );
                const account = accounts[0];
                const coinbase = await web3.eth.getCoinbase();

                if (!coinbase) {
                    this.$vs.notify({
                        title: 'Wallet Connection',
                        text: 'Please activate MetaMask.',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'warning',
                    });
                    this.isRequestingAccounts = false;
                    return;
                }

                this.publicAddress = account.toLowerCase();
                this.isMetamaskConnected = true;

                // Fetch nonce and sign
                await this.handleNonceAndSign(this.publicAddress);
            } catch (error) {
                this.handleConnectionError(error);
            } finally {
                this.isRequestingAccounts = false;
                document.getElementById('loading-bg-transparent').style.display = 'none';
            }
        },
        async handleNonceAndSign(publicAddress) {
            try {
                const res = await this.$store.dispatch('auth/v2getNonce', {
                    address: publicAddress,
                });
                await this.handleSignMessage(publicAddress, res.data.nonce, res.data.token);
            } catch (error) {
                this.$vs.notify({
                    title: 'Wallet Connection',
                    text: 'Failed to connect wallet. Please try again.',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger',
                });
                this.disconnectWallet();
            }
        },
        async handleSignMessage(publicAddress, nonce, token) {
            document.getElementById('loading-bg-transparent-title').innerText =
                'Signing to MetaMask';
            document.getElementById('loading-bg-transparent').style.display = 'flex';

            try {
                const web3 = new Web3(Web3.givenProvider);
                const signature = await web3.eth.personal.sign(nonce, publicAddress, '');

                const response = await this.$store.dispatch('auth/v2sendSignatureConnect', {
                    token,
                    signature,
                });

                const isTwoFactorAuthEnabled = response.data?.twoFactorAuthentication;
                if (isTwoFactorAuthEnabled) {
                    const twoFactorToken = response.data?.token;
                    this.$router.push({ name: 'TwoFactor', query: { tempToken: twoFactorToken } });
                } else {
                    this.$vs.notify({
                        title: 'Wallet Connection',
                        text: 'Wallet connected successfully!',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'success',
                    });
                }
            } catch (error) {
                this.$vs.notify({
                    title: 'Wallet Connection',
                    text: 'Failed to sign message. Please try again.',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'warning',
                });
                this.disconnectWallet();
            } finally {
                document.getElementById('loading-bg-transparent').style.display = 'none';
            }
        },
        disconnectWallet() {
            this.isMetamaskConnected = false;
            this.publicAddress = '';

            // Clear localStorage
            localStorage.removeItem('metamaskConnected');
            localStorage.removeItem('metamaskAddress');

            this.$vs.notify({
                title: 'Wallet Disconnected',
                text: 'Wallet has been disconnected.',
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'success',
            });
        },
        async checkMetamaskConnection() {
            const isConnected = localStorage.getItem('metamaskConnected');
            const storedAddress = localStorage.getItem('metamaskAddress');

            if (isConnected === 'true' && storedAddress) {
                try {
                    const web3 = new Web3(Web3.givenProvider);
                    const accounts = await web3.eth.getAccounts();
                    if (accounts.length > 0 && accounts[0].toLowerCase() === storedAddress) {
                        this.isMetamaskConnected = true;
                        this.publicAddress = storedAddress;
                    } else {
                        // Clear stored data if no accounts are connected or mismatch
                        this.disconnectWallet();
                    }
                } catch (error) {
                    console.error('Error checking MetaMask connection:', error);
                    this.disconnectWallet();
                }
            }
        },
        withTimeout(promise, timeout = 15000) {
            return Promise.race([
                promise,
                new Promise((_, reject) =>
                    setTimeout(() => reject(new Error('MetaMask timeout')), timeout)
                ),
            ]);
        },
        handleConnectionError(error) {
            if (error.code === -32002) {
                this.$vs.notify({
                    title: 'Wallet Connection',
                    text: 'MetaMask is already processing a request. Please check the extension.',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'warning',
                });
            } else if (error.message === 'MetaMask timeout') {
                this.$vs.notify({
                    title: 'Wallet Connection',
                    text: 'No response from MetaMask. You may have closed the popup.',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'warning',
                });
            } else {
                console.error('MetaMask Connection Error:', error);
                this.$vs.notify({
                    title: 'Wallet Connection',
                    text: 'An error occurred while connecting to MetaMask.',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger',
                });
            }
        },
    },
};
</script>

<style scoped>
.connect_info_container {
    display: flex;
    flex-direction: column;
    gap: 1rem;
}

address {
    font-style: normal;
    color: #a0aec0;
}

button.bg-primary {
    background-color: #48bb78;
    /* Adjust to match your primary color */
}

button.bg-primary:hover {
    background-color: #38a169;
    /* Adjust to match your lime-500 hover color */
}
</style>